import { invalidateCartSummaryQuery } from './useCartSummaryQuery';
import { invalidateShoppingCartProducts } from './useShoppingCartProducts';
import { invalidateCartGroupedItems } from './useCartGroupedItems';
import { invalidateCartAggregations } from '../../shop/cart/useCartAggregations';
import { ErrorResponse, globalErrorResponse } from '../../shared/notification/actions';
import { shopPrefix } from '../../config';
import { http } from '../axios';
import { useMutation } from '@tanstack/react-query';

export function useDeleteCart() {
    return useMutation(() => deleteCart(), {
        onSuccess: () => {
            invalidateCartSummaryQuery().then();
            invalidateShoppingCartProducts().then();
            invalidateCartGroupedItems().then();
            invalidateCartAggregations().then();
        },
        onError: (error: ErrorResponse) => globalErrorResponse(error)
    });
}

async function deleteCart() {
    return http.delete<void>(`${shopPrefix}/v1/shoppingcart/products`);
}
